<script>
import BaseConfig from '@/plans/MASTER_CLASS/config/base';

export default {
  mixins: [BaseConfig],
};
</script>
